import SortHelper from "helpers/SortHelper";
import * as ConfigTypes from 'config/ConfigTypes';
import * as CartHelper from 'helpers/CartHelper';

export const getMetaConfig = ({ viewMode, props, configName }) => {
  //const { config } = props.mediaObjects;
  const { config } = props.configObjects;
  let fields;
  if (config && config[configName].length > 0) {
    fields = config[configName]
      .filter((el) => el.params && el.params[viewMode])
      .map((el) => ({
        ...el,
        [`${viewMode}order`]: el.params[viewMode].order,
        [`${viewMode}html`]: el.params[viewMode].html,
        [`${viewMode}verSpace`]: el.params[viewMode].verSpace,
        [`${viewMode}group`]: el.params[viewMode].group,
        [`${viewMode}labelField`]: el.params[viewMode].labelField,
        [`${viewMode}catalog`]: el.params[viewMode].catalog,
        [`${viewMode}form`]: el.params[viewMode].form,
        [`${viewMode}searchtype`]: el.params[viewMode].searchtype,
        [`${viewMode}type`]: el.params[viewMode].type,
        [`${viewMode}heading`]: el.params[viewMode].heading,
        [`${viewMode}description`]: el.params[viewMode].description,
        [`${viewMode}filterType`]: el.params[viewMode].filterType,
        [`${viewMode}column`]: el.params[viewMode].column,
        [`${viewMode}maxLength`]: el.params[viewMode].maxLength,
        [`${viewMode}noLabelList`]: el.params[viewMode].noLabelList,
        [`${viewMode}datetype`]: el.params[viewMode].datetype,
        [`${viewMode}languagetype`]: el.params[viewMode].languagetype,
        [`${viewMode}unittype`]: el.params[viewMode].unittype,
        [`${viewMode}addTo`]: el.params[viewMode].addTo,
        [`${viewMode}hidden`]: el.params[viewMode].hidden,
        [`${viewMode}isReduced`]: el.params[viewMode].isReduced,
        [`${viewMode}intl`]: el.params[viewMode].intl,
        [`${viewMode}data`]: el.params[viewMode].data,
        [`nointl`]: el.params[viewMode].nointl,
        [`optionAsIntl`]: el.params[viewMode].optionAsIntl,
        [`optionAsMapp`]: el.params[viewMode].optionAsMapp,
        [`options`]: el.params[viewMode].options || el.options,
        [`${viewMode}extra`]: el.params[viewMode].extra || el.extra,
        [`${viewMode}parents`]: el.params[viewMode].parents,
      }));

    fields = setDisplayConfig({ fields, dialogMode: viewMode });

    fields = SortHelper.sortByValue({
      data: fields,
      sorted: "asc",
      field: `${viewMode}order`,
      isNumber: true,
    });
  }
  return fields;
};

export const getDropdownData = ({ item, viewMode }) => {
  if (item && item.options && item.options.length) {
    return item.options.map(option => {
      let value = option.split("=")[0];
      if (!value) value = "";
      let intl = `dropdown.${viewMode}.${value}`;
      if (item.nointl) intl = value;
      if (item.optionAsIntl) intl = option.split("=")[1] || "";
      return { name: value, intl, value }
    })
  }
  return [];
}

export const getAutoDdData = ({ item, type, options }) => {
  const { func, fields } = type;
  let data = [];
  if (func && fields) {
    if (options && options.length) {
      data = options.map(item => ({
        name: item[fields[1]], intl: item[fields[0]],
        value: item[fields[1]]
      }));
    }
  }
  data.unshift({ name: item.name, intl: item.name, value: '' });
  return data;
}

export const checkAndSetOtherProps = ({ fields, dialogMode }) => {
  let newFields = [];
  let currentOrder;
  fields.forEach(item => {
    currentOrder = item.order;
    if (item[`${dialogMode}intl`]) item.intl = item[`${dialogMode}intl`];
    newFields.push(item);
    if (item[`${dialogMode}linebreak`]) {
      let order = currentOrder + 1;
      let addTo = item[`${dialogMode}addTo`] || item.addTo;
      if (item[`${dialogMode}noline`]) {
        newFields.push({ name: 'breakline', type: ConfigTypes.BREAKLINE, noLine: true, order, addTo });
      } else {
        newFields.push({ name: 'breakline', type: ConfigTypes.BREAKLINE, order, addTo });
      }
    }
  });

  return newFields;
}

export const setDisplayConfig = ({ fields, dialogMode }) => {
  let parents = [];
  let hasChildren = false;
  fields.forEach(item => {
    if (item[`${dialogMode}parents`]) {
      if (item[`${dialogMode}parents`].isFirst) {
        let newItem = item[`${dialogMode}parents`];
        newItem.children = [];
        delete item.parents;
        item.isFirst = true;
        newItem.children.push(item);
        parents.push(newItem);
      } else {
        let index = parents.findIndex(entry => entry.name == item[`${dialogMode}parents`].name);
        if (index > -1) {
          delete item.parents;
          if (parents[index] && parents[index].children) {
            parents[index].children.push(item);
          }
        }
      }
      hasChildren = true;
    } else {
      parents.push(item);
    }
  });
  if (hasChildren) fields = parents;
  return fields;
}

export const getDialogConfig = ({ dialogMode, configObjects, configName }) => {
  let fields = [];
  if (configObjects) {
    const { customerConfig } = configObjects;
    if (customerConfig && customerConfig[configName].length > 0) {
      fields = customerConfig[configName]
        .filter((el) => el.params && el.params[dialogMode])
        .map((el) => ({
          ...el,
          //[`${dialogMode}order`]: el.params[dialogMode].order,
          [`order`]: el.params[dialogMode].order,
          [`${dialogMode}parents`]: el.params[dialogMode].parents,
          [`${dialogMode}linebreak`]: el.params[dialogMode].linebreak,
          [`${dialogMode}noline`]: el.params[dialogMode].noline,
          [`${dialogMode}intl`]: el.params[dialogMode].intl,
          [`${dialogMode}addTo`]: el.params[dialogMode].addTo,
          [`${dialogMode}noLabelList`]: el.params[dialogMode].noLabelList,
          [`type`]: el.params[dialogMode].type,
          ["withLabel"]: el.params[dialogMode].withLabel,
          [`data`]: el.params[dialogMode].data,
          [`required`]: el.params[dialogMode].required,
          [`notFillIn`]: el.params[dialogMode].notFillIn,
          [`isFirst`]: el.params[dialogMode].isFirst,
          [`inActive`]: el.params[dialogMode].inActive,
          [`plus`]: el.params[dialogMode].plus,
          [`check`]: el.params[dialogMode].check,
          [`appendObj`]: el.params[dialogMode].appendObj,
          originalname: el.name,
          name: el.field,
        }));

      fields = setDisplayConfig({ fields, dialogMode });
      fields = checkAndSetOtherProps({ fields, dialogMode });
      fields = SortHelper.sortByValue({
        // data: fields, sorted: "asc", field: `${dialogMode}order`, isNumber: true
        data: fields, sorted: "asc", field: `order`, isNumber: true
      });
    }
  }

  return fields;
};


export const getNewItems = ({ fields, item, dialogMode, isChild = false }) => {
  let newFields = fields.filter(field => {
    let addTo = field[`${dialogMode}addTo`];
    if (isChild) {
      if ((addTo && addTo.column === item.name) || (field.addTo && field.addTo.column === item.name)) return true;
    } else if ((addTo && addTo.row === item.name) || (field.addTo && field.addTo.row === item.name)) return true;


    return false;
  });
  return newFields;
}

export const getCartRequestData = ({ fields, dialogMode }) => {
  let data = [...CartHelper.CARTREQUEST_CONTENT_ITEMS];
  let newData = data.map(item => {
    let newFields = getNewItems({ item, fields, dialogMode });
    if (item.children && item.children.length) {
      item.children.map(child => {
        let newChildren = getNewItems({ item: child, fields: newFields, dialogMode, isChild: true });
        if (newChildren && newChildren.length > 0) child.children = newChildren;
        return child;
      })
    }
    return item;
  });

  return newData;
}

export const addToCartRequestData = ({ fields, dialogMode, data }) => {
  let newData = data.map(item => {
    let newFields = getNewItems({ item, fields, dialogMode });
    if (item.children && item.children.length) {
      item.children.map(child => {
        let newChildren = getNewItems({ item: child, fields: newFields, dialogMode, isChild: true });
        if (newChildren && newChildren.length > 0) {
          if (!child.data) child.data = [];
          child.data = SortHelper.sortByValue({
            data: newChildren, sorted: "asc", field: `${ConfigTypes.CART_REQUEST}order`, isNumber: true
          });
        }
        return child;
      })
    }
    return item;
  });

  return newData;
}

